'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSettingsInputSvideo = function MdSettingsInputSvideo(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.9 25q1 0 1.7 0.7t0.8 1.8-0.8 1.8-1.7 0.7-1.8-0.7-0.7-1.8 0.7-1.8 1.8-0.7z m3.2-8.4q1.1 0 1.8 0.8t0.7 1.7-0.7 1.8-1.8 0.7-1.7-0.7-0.8-1.8 0.8-1.7 1.7-0.8z m-9.1 18.4q6.3 0 10.6-4.4t4.4-10.6-4.4-10.6-10.6-4.4-10.6 4.4-4.4 10.6 4.4 10.6 10.6 4.4z m0-33.4q7.6 0 13 5.4t5.4 13-5.4 13-13 5.4-13-5.4-5.4-13 5.4-13 13-5.4z m-5.9 23.4q1.1 0 1.8 0.7t0.7 1.8-0.7 1.8-1.8 0.7-1.7-0.7-0.8-1.8 0.8-1.8 1.7-0.7z m10.9-14.1q0 1-0.7 1.7t-1.8 0.8h-5q-1.1 0-1.8-0.8t-0.7-1.7 0.7-1.8 1.8-0.7h5q1.1 0 1.8 0.7t0.7 1.8z m-11.6 8.2q0 1.1-0.8 1.8t-1.7 0.7-1.8-0.7-0.7-1.8 0.7-1.7 1.8-0.8 1.7 0.8 0.8 1.7z' })
        )
    );
};

exports.default = MdSettingsInputSvideo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/settings-input-svideo.js
// module id = 3314
// module chunks = 0